module.exports = __webpack_public_path__ + "img/logo-mobile.e41344f3254831f7a7c28253527c1d35.svg";